<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" epub:type="dedication" id="dedication" role="doc-dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">This book is dedicated to two of my greatest encouragers, Rita Wilkinson, a lady I met when speaking at a WI meeting who has been a constant source of encouragement. Thank you, Rita for your support.</p>
<p class="subsq dedication-content">And also, at the other side of the world, Kelly Ferret, a lady whose enthusiasm and messages lift my spirits. I’ll try to write more quickly for you, Kelly!</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?9ba25382